export function scaleScore(score: { min: number, max: number, raw: number }, range: { min: number, max: number }) {
  if (score.max - score.min === 0) {
    return 0
  }
  
  const scaled = range.min + (range.max - range.min) * ((score.raw - score.min) / (score.max - score.min));
  return scaled
}
